module.exports = __webpack_public_path__ + "static/media/bowman.450cef0a.jpg";